import getTaskType from '../../utils/getTaskType';
import { getTimeZoneOffset, getDateFromDateString, getTimeFromDateString } from '../../utils/utils';

class TaskSingle {
  constructor(task = {}) {
    this.id = task.id || '';
    this.extId = task.extId || '';

    this.globalTaskId = task.globalTaskId || null;
    this.regularTaskId = task.regularTaskId || null;

    this.type = task.type || getTaskType(false, false, false);

    this.title = task.title || '';
    this.subtitle = task.subtitle || '';
    this.description = task.description || '';
    this.note = task.note || '';

    this.date = task.date || '';
    this.timeZone = task.timeZone === 0 ? task.timeZone : task.timeZone || getTimeZoneOffset();
    this.time = task.time || '';
    this.timeNeed = Number(task.timeNeed) || 0;

    this.importance = task.importance || false;
    this.done = task.done || false;

    this.delayedTaskId = task.delayedTaskId || null;

    this.labels = task.labels || [];

    // tasks structure
    this.taskGlobal = task.taskGlobal || null;
    this.taskRegular = task.taskRegular || null;
  }

  getCreateTaskSingleDto() {
    const serverModel = {
      globalTaskId: null,
      regularTaskId: null,
      title: null,
      subTitle: null,
      description: null,
      note: null,
      timeNeed: null,
      isImportant: null,
      isDone: null,
      date: null,
      time: null,
      timeZone: null,
    };
    if (this.globalTaskId) serverModel.globalTaskId = this.globalTaskId;
    if (this.regularTaskId) serverModel.regularTaskId = this.regularTaskId;
    if (this.title) serverModel.title = this.title;
    if (this.subtitle) serverModel.subTitle = this.subtitle;
    serverModel.description = this.description;
    serverModel.note = this.note;
    serverModel.timeNeed = this.timeNeed * 60 || 0; // to minutes
    if (this.labels) serverModel.labels = this.labels;
    serverModel.isImportant = this.importance || false;
    serverModel.isDone = this.done || false;
    if (this.date) serverModel.date = this.date;
    if (this.timeZone || this.timeZone === 0) serverModel.timeZone = getTimeZoneOffset();
    if (this.time) serverModel.time = new Date(new Date(this.date).setHours(Number(this.time.split(':')[0]), Number(this.time.split(':')[1]), 0));
    Object.keys(serverModel).forEach((key) => {
      if (serverModel[key] === null) {
        delete serverModel[key];
      }
    });
    if (this.delayedTaskId) serverModel.delayedTaskId = this.delayedTaskId;

    if (!this.time) serverModel.time = null;

    return serverModel;
  }

  getTaskSingle(serverModel) {
    this.id = serverModel.id || '';
    this.extId = serverModel.extId || '';

    this.globalTaskId = serverModel.globalTaskId || null;
    this.regularTaskId = serverModel.regularTaskId || null;

    this.type = getTaskType(false, false, false);

    this.title = serverModel.title || '';
    this.subtitle = serverModel.subTitle || '';
    this.description = serverModel.description || '';
    this.note = serverModel.note || '';

    this.date = serverModel.date ? getDateFromDateString(serverModel.date) : '';
    this.timeZone = serverModel.timeZone === 0 ? serverModel.timeZone : serverModel.timeZone || getTimeZoneOffset();
    this.time = serverModel.time ? getTimeFromDateString(serverModel.time, this.timeZone) : '';
    this.timeNeed = Number(serverModel.timeNeed) / 60 || 0; // to hours

    this.importance = serverModel.isImportant || false;
    this.done = serverModel.isDone || false;

    this.labels = serverModel.labels || [];

    // tasks structure
    this.taskGlobal = serverModel.taskGlobal || null;
    this.taskRegular = serverModel.taskRegular || null;

    return this;
  }
}

export default TaskSingle;
